export default __webpack_public_path__ + "static/media/wpiece.f3921918.png";